//#region ../src/visualization/vis-colors.ts
/**
* Centralized Visualization Color Palette
*
* Single source of truth for all semantic colors used across the app's
* visualization layers (Three.js 3D scene and Leaflet 2D summary map).
*
* Each entry provides both hex (number, for Three.js) and css (string,
* for Leaflet/CSS) formats. Some entries intentionally use different 3D/2D
* shades — see inline comments.
*
* Tailwind classes in index.html (e.g., bg-yellow-400) cannot be dynamically
* generated and must be kept in sync manually — search for "vis-colors" in
* the HTML legend to find them.
*/
const VIS_COLORS = {
	/** Raw GPS marker — yellow */
	RAW_GPS: {
		hex: 16776960,
		css: "#ffff00"
	},
	/** Fused VIO marker — cyan */
	FUSED_VIO: {
		hex: 65535,
		css: "#00ffff"
	},
	/** Alignment snapshot marker — red */
	ALIGNMENT_SNAPSHOT: {
		hex: 16711680,
		css: "#ff0000"
	},
	/** Prior reference point — green */
	PRIOR_REF_POINT: {
		hex: 65280,
		css: "#00ff00"
	},
	/** Current reference point — bright red in 3D, lighter red (#ff6b6b) in 2D for map visibility */
	CURRENT_REF_POINT: {
		hex: 16711680,
		css: "#ff6b6b"
	},
	/** Compass north indicator — red */
	COMPASS_NORTH: {
		hex: 16711680,
		css: "#ff0000"
	},
	/** Compass east indicator — blue */
	COMPASS_EAST: {
		hex: 255,
		css: "#0000ff"
	},
	/** Compass south indicator — dark red */
	COMPASS_SOUTH: {
		hex: 8930372,
		css: "#884444"
	},
	/** Compass west indicator — dark blue */
	COMPASS_WEST: {
		hex: 4473992,
		css: "#444488"
	},
	/** Compass up indicator — green */
	COMPASS_UP: {
		hex: 65280,
		css: "#00ff00"
	},
	/** User GPS position marker — blue */
	USER_POSITION: {
		hex: 3900150,
		css: "#3b82f6"
	}
};
//#endregion
export { VIS_COLORS };
